'use client';
import { isFunction } from '@s7/utils';
import { useQuery } from './useQuery.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var createQuery = function(definition, context) {
    if (!isFunction(definition)) {
        return function(options) {
            return useQuery(_extends({}, context, definition, options));
        };
    }
    if (!definition.length) {
        return function(options) {
            return(// @ts-expect-error void argument
            useQuery(_extends({}, context, definition(), options)));
        };
    }
    return function(input, options) {
        return useQuery(_extends({}, context, definition(input), options));
    };
};

export { createQuery };
